<script>
    import user from '../stores/user';
    import groups from "../stores/groups";
    import members from "../stores/members";
    import success from '../stores/success';
    import app_alert from "../stores/alerts";
    import {JSONClone} from '../lib/lib';
    import {memberSave, memberDelete} from "../requests";
    import {GROUP_TYPE} from "../lib/constants";
    import GroupToggleControl from '../groups/GroupToggleControl.svelte';

    let member = null;
    let memberGroups = [];
    let error = null;

    const close = () => {
        memberGroups = [];
        error = null;
        member = null;
        members.closeMember();
    }

    const toggleGroup = ({detail}) => {
        member.in_groups = [];
        memberGroups.map(item => {
            if (item.selected) {
                member.in_groups.push(item.id);
            }
        });
    }


    const save = async () => {
        error = null;

        if (!member.lname && !member.fname) {
            error = "Πρέπει να εισάγετε το επίθετο ή το όνομα της επαφής";
            return;
        }
        if (!member.mobile) {
            error = "Δεν έχετε εισάγει το κινητό τηλέφωνο της επαφής";
            return;
        }

        const [err, res] = await memberSave(member);

        if (err) {
            error = err;
            return;
        }

        members.updateMember(res);

        if (member.id == 0) {
            success.show("Δημιουργήθηκε νέα επαφή.");
        } else {
            success.show("Η επαφή ενημερώθηκε.");
        }

        close();
    }

    const onDelete = () => {
        app_alert.show('confirm', `Να διαγραφεί η επαφή "${member.lname} ${member.fname}";`, async () => {
            const [err, res] = await memberDelete(member.id);
            if (err) {
                return;
            }
            members.deleteMember(member.id);
            success.show("Η επαφή διαγράφτηκε.");

            // remove member from groups total phones
            member.in_groups.map(group_id => {
                let group = $groups.list.find( x=> x.id == group_id);
                if (group.total_mobiles > 0) {
                    group.total_mobiles--;
                }
            });
            $groups.list = $groups.list;

            close();
        });
    }

    const initialize = memberId => {
        if (memberId === undefined || memberId === null) {
            member = null;
        }
        if (memberId !== undefined && memberId !== null && memberId != 0) {
            member = $members.list.find(x => x.id == memberId);
        }
        if (memberId === 0) {
            member = {
                id: 0,
                lname: "",
                fname: "",
                occupation: "",
                mobile: "",
                in_groups: [],
                client_id: $user.id,
            }
        }

        if (member !== null) {
            $groups.list.map(group => {
                if (group.type == GROUP_TYPE.GROUP_MEMBERS) {
                    let clone = JSONClone(group);
                    clone.selected = member.in_groups.indexOf(clone.id) > -1;
                    memberGroups = [...memberGroups, clone];
                }
            });
        }
    }

    $: {
        initialize($members.editMemberId);
    }

</script>

{#if member !== null}
    <div class="popup-overlay visible">
        <div class="modal modal-xs">
            <div class="modal-header">
                <div class="modal-title">
                    { member.id == 0 ? 'Νέα επαφή' : 'Επεξεργασία επαφής' }
                </div>
                <div class="controls-right">
                    <span on:click="{ members.closeMember }"><i class="fa fa-times"></i></span>
                </div>
            </div>
            <div class="modal-body">
                <div class="form-group">
                    <label>Επίθετο</label>
                    <input type="text" bind:value="{ member.lname }" class="form-control">
                </div>
                <div class="form-group">
                    <label>Όνομα</label>
                    <input type="text" bind:value="{ member.fname }" class="form-control">
                </div>
                <div class="form-group">
                    <label>Ιδιότητα</label>
                    <input type="text" bind:value="{ member.occupation }" class="form-control">
                </div>
                <div class="form-group">
                    <label>Κινητό</label>
                    <input type="text" bind:value="{ member.mobile }" class="form-control">
                </div>

                <label>Ομάδες επαφών</label>
                <div class="mrg-b-md">
                    {#each memberGroups as group}
                        <GroupToggleControl group="{ group }" allowActions={ false } showTotalMembers={ false }
                                            on:toggle="{ toggleGroup }"/>
                    {/each}
                </div>

                {#if (error)}
                    <div class="alert alert-danger">{error}</div>
                {/if}
                <div class="row">
                    <div class="col-md-4">
                        {#if member.id > 0}
                            <button class="btn btn-danger" title="Διαγραφή επαφής" on:click="{ onDelete }">Διαγραφή</button>
                        {/if}
                    </div>
                    <div class="col-md-8 text-right">
                        <button class="btn btn-primary" title="Ενημέρωση επαφής" on:click="{ save }">OK</button>
                        <button class="btn btn-default" title="Κλείσιμο" on:click="{ close }">Ακύρωση</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}